//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PELD_score',
  data() {
    return {
      form: {
        serum: '',
        bilirubin:'',
        rate:'',
        age:'0',
        growing:'0'
      },
      hasScore: false,
      disabled: false,
      num: '',
      num1: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = ''
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        self.hasScore = true;
        result = (0.480 * Math.log(form.bilirubin) + 1.857 * Math.log(form.rate) -
        0.687 * Math.log(form.serum) + (form.age ? 0.436 : 0) + 
        (form.growing ? 0.667 : 0) * 10).toFixed(3)
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/PELD_score.vue